import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import discover150 from "../../images/discover-150.jpg";
import "../../../src/product.css";

const Discover150 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">DISCOVER 150cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={discover150}
              alt="Bajaj Discover 150cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Discover 150 is an affirmation in the belief that power and
              mileage can coexist. It is a bike that combines technologies to
              deliver a powerful and economical ride. A bike that blends
              design along with engineering to give you what you desire the
              most from your vehicle: an unadulterated & exciting ride.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>145 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>121 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>102 Kmph</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Discover150;